// alterado - revisado

import React from 'react'

import {
    COLOR
} from '../../../business-const/Color/Color'

import LABEL from '../../../business-const/Label/Label'

import {
    formataValor,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
} from '../../../business-components/Grid/Grid'

import {
    anoPrimeiraLetraMaiscula,
} from './EstudoService'

import {
    calculaGridItemCenariosEstudosTabelaGrafico,
} from './EstudoServiceComparacaoCenariosEstudos'



                                    
const EstudoFormComparacaoCenariosEstudosTabelaGrafico = ({ comparacaoCenariosEstudos, comparacaoCenariosEstudosSeries,
    comparacaoCenariosEstudosIdades, comparacaoCenariosEstudosAnos, indInicial, indFinal }) => {

    const GridItem = calculaGridItemCenariosEstudosTabelaGrafico(comparacaoCenariosEstudos, false)//report)

    const ComparacaoCenariosEstudos = () => {

        return (
            <table
                border='0'
                cellPadding='0'
                cellSpacing='0'
                width='100%'
                className='mt-2'
                style={{
                    paddingTop: '0px',
                    paddingRight: '2px',
                    paddingLeft: '2px',
                    //paddingBottom: '10px',
                }}
            >
                <tbody>
                        <tr>
                            <td
                                width='100%'
                            >
                                <table
                                    className={'mt-2'}
                                    border='0'
                                    cellPadding='0'
                                    cellSpacing='0'
                                    width='100%'
                                    style={{
                                        padding: '5px',
                                    }}
                                >
                                    <tbody>
                                        <tr>
                                            <td
                                                className={'text-white text-14'}
                                                bgcolor={COLOR().bgComparacaoCenariosEstudosGrupo}
                                                align="center"
                                                width={'5%'}
                                                style={{
                                                    padding: '5px',
                                                }}
                                            >
                                                {anoPrimeiraLetraMaiscula()}
                                            </td>
                                            <td
                                                className={'text-white text-14'}
                                                bgcolor={COLOR().bgComparacaoCenariosEstudosGrupo}
                                                align="center"
                                                width={'5%'}
                                                style={{
                                                    padding: '5px',
                                                }}
                                            >
                                                {LABEL.idade}
                                            </td>
                                            {comparacaoCenariosEstudos?.map((linhaCenarioEstudo, indCenarioEstudo) => {
                                                return (
                                                    <td
                                                        key={indCenarioEstudo}
                                                        className={'font-bold text-9'}
                                                        align="center"
                                                        width={'10%'}
                                                        style={{
                                                            padding: '5px',
                                                        }}
                                                    >
                                                        {<span dangerouslySetInnerHTML={{ __html: linhaCenarioEstudo.descricao}} />}
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                        {comparacaoCenariosEstudosIdades?.map((item, ind) => {
                                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                                <tr
                                                    key={ind}
                                                    className={'text-white font-light text-9'}
                                                    bgcolor={COLOR().bgComparacaoCenariosEstudosItem}
                                                >
                                                    <td
                                                        className={'font-light-medium text-9'}
                                                        align="center"
                                                        width={'5%'}
                                                        style={{
                                                            border: '1px solid',
                                                            padding: '5px',
                                                        }}
                                                    >
                                                        <span className='text-black text-13'>
                                                            {comparacaoCenariosEstudosAnos[ind]}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className={'font-light-medium text-9'}
                                                        align="center"
                                                        width={'5%'}
                                                        style={{
                                                            border: '1px solid',
                                                            padding: '5px',
                                                        }}
                                                    >
                                                        <span className='text-black text-13'>{item}</span>
                                                    </td>
                                                    {comparacaoCenariosEstudos?.map((linhaCenarioEstudo, indCenarioEstudo) => {
                                                        return (
                                                            <td
                                                                key={indCenarioEstudo}
                                                                width={'10%'}
                                                                bgcolor={
                                                                    (indCenarioEstudo + 1) % 2 === 0
                                                                        ?
                                                                            COLOR().bgComparacaoCenariosEstudosItem
                                                                        :
                                                                            COLOR().bgComparacaoCenariosEstudosItem2
                                                                }
                                                                align= 'center'
                                                                style={{
                                                                    border: '1px solid',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <span
                                                                    className={
                                                                        comparacaoCenariosEstudosSeries[indCenarioEstudo].data[ind] >= 0
                                                                            ?
                                                                                'text-black text-13'
                                                                            :
                                                                                'text-error font-medium text-13'
                                                                    }
                                                                >
                                                                    {formataValor(
                                                                        comparacaoCenariosEstudosSeries[indCenarioEstudo].data[ind], 2, true)}
                                                                </span>
                                                            </td>
                                                        )
                                                    })}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                </tbody>
            </table>
        )
    }

    return (
        comparacaoCenariosEstudos && comparacaoCenariosEstudosSeries && comparacaoCenariosEstudosIdades && GridItem
            ?
                <GridContainer
                    className='mt--12'
                >
                    <GridItem>
                        <ComparacaoCenariosEstudos/>
                    </GridItem>
                </GridContainer>
            :
                ''
    )
}

export default EstudoFormComparacaoCenariosEstudosTabelaGrafico